import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import plugins from './plugins/index.js'
import behavior from './plugins/behavior/index.js'
import './styles.styl'
import {initDocumentFontSize, hmt} from './utils/index.js'
// import './flexboxgrid.min.css'
// import {config} from '@/api/config'
import sa from './plugins/Sa'

initDocumentFontSize()
Vue.use(behavior)
Vue.use(sa)
hmt()
Vue.use(plugins)
Vue.config.productionTip = false
new Vue({
  store,
  render: h => h(App),
  wechat: plugins.wechat,
  router
}).$mount('#app')

window.mediaQueue = []
